import * as initialConfigs from 'constants/chartsConstants';
import { getPlotOptions, getToolTip } from './chartHelpers';

export const generateChartConfig = ({
  seriesData, chartType, titleText, subtitleText, yAxisTitle, legendConfig, stacked, colors, percentage, height
}) => {

  const { title, subtitle } = initialConfigs;
  const series = stacked ? { stacking: 'normal' } : {};
  const initialConfig = initialConfigs;
  const plotOptions = getPlotOptions(percentage);
  const newPlotOptions = {
    ...plotOptions, series: {
      ...series,
      events: {
        legendItemClick: function () {
          return false;
        }
      }
    }
  };
  const max = percentage ? 100 : max;
  const chart = {
    type: chartType,
    height
  };
  const toolTip = getToolTip(percentage);
  const titleConfig = { ...title, text: titleText };
  const subtitleConfig = { ...subtitle, text: subtitleText, };
  const yAxis = {
    className: 'axis-title',
    title: {
      text: yAxisTitle,
    },
    max,
    lineWidth: 1,
    reversedStacks: false,
    allowDecimals: false,
    stackLabels: {
      enabled: true,
      formatter: function () {
        return Math.abs(this.total);
      }
    }
  };

  const chartConfig = {
    ...initialConfig,
    ...seriesData,
    legend: {
      ...initialConfig.legend,
      ...legendConfig
    },
    toolTip,
    colors,
    chart,
    plotOptions: newPlotOptions,
    yAxis,
    title: titleConfig,
    subtitle: subtitleConfig
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./src/utils/generateChartConfig.js